import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Card,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  CardBody,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { tabChange } from "../Utils/SetDefaultRowData";
import { PAGE_TITLES } from "../Common/constants";
import BreadCrumb from "../Common/BreadCrumb";
import OperatorDetails from "./operatorViewTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchOperatorbyId } from "../../slices/OperatorManagement/GetOperatorbyID/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { OperatorStatusOptions } from "./Constant/Options";
import { Loader } from "../Utils/Loader";
import UserListingOperator from "./UserListingforOperator";
import { viewDoc } from "../../slices/customer/documentview/thunk";

function OperatorView() {
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState();
  const [editData, setEditData] = useState();
  const [profileData, setProfileData] = useState(null);

  const dispatch = useDispatch();
  const operatorId = customerIdData();
  const operatorOptions = [];
  const initialValues = {};

  useEffect(() => {
    dispatch(
      fetchOperatorbyId(
        setLoading,
        operatorId,
        initialValues,
        operatorOptions,
        OperatorStatusOptions,
        setEditData
      )
    );
  }, [dispatch, setLoading]);

  const operatorData = useSelector(
    (state) => state?.GetOperator?.GetOperatorId
  );

  useEffect(() => {
    if (operatorData && operatorData?.operatorId) {
      let partnerOrCustomer = "Operator";
      dispatch(
        viewDoc(
          setLoading,
          operatorData?.operatorId,
          "logo",
          partnerOrCustomer,
          setProfileData
        )
      );
    }
  }, [dispatch, operatorData]);

  return (
    <div id="csms" className="page-content">
      <Container fluid>
        <BreadCrumb
          title={PAGE_TITLES.VIEW_OPERATOR}
          pageTitle={PAGE_TITLES.OPERATOR_LIST}
          moduleTitle={PAGE_TITLES.OPERATOR_LIST}
        />
        {loading && <Loader />}
        <Nav className="nav-tabs-custom card-header-tabs mb-4 " role="tablist">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                tabChange("1", activeTab, setActiveTab);
              }}
            >
              <i className="fas fa-home"></i>
              Overview
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to="#"
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                tabChange("2", activeTab, setActiveTab);
              }}
              type="button"
            >
              <i className="far fa-envelope"></i>
              Users
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <OperatorDetails
              setLoading={setLoading}
              operatorData={operatorData}
              profileData={profileData}
            />
          </TabPane>
          <TabPane tabId="2">
            <UserListingOperator 
              domain={operatorData.domain}
            />
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
}

export default OperatorView;
